// extracted by mini-css-extract-plugin
module.exports = {"root":"LinkButton_root__3gg7J","isSecondary":"LinkButton_isSecondary__3Tdqk","isThirdly":"LinkButton_isThirdly__2ylmb"};